import type {Moment} from 'moment-timezone'

import {getStoragesFromHistory, isHistoryStorageWithMaterialGuard} from '../selectors/storages'

import {useMaterialStorageHistory} from './useMaterialStorageHistory'

interface UseHistoryStoragesWithMaterialQueryParams {
  plantId: string
  timeFrame: [Moment, Moment]
  date?: Moment
  throwOnError?: boolean
}

export const useHistoryStoragesWithMaterialQuery = ({
  plantId,
  timeFrame: [from, to],
  date,
  throwOnError = true
}: UseHistoryStoragesWithMaterialQueryParams) =>
  useMaterialStorageHistory({
    plantId,
    from: from.toISOString(),
    to: to.toISOString(),
    options: {
      select: (storagesHistory) =>
        getStoragesFromHistory(storagesHistory, date ?? to).filter(
          isHistoryStorageWithMaterialGuard
        ),
      throwOnError
    }
  })
